module.exports = __webpack_public_path__ + "img/u60.0566941c.svg";